import React, { useState } from "react";
import { Box, InputLabel, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { SidebarIcon } from "../../Utils/handler";
import TextLabel from "./CommonTextLabel";
import ButtonContained from "./ButtonContained";

const Input = styled("input")({
    display: "none",
});

const CommonFileUpload = ({
    onChange,
    accept,
    name,
    text,
    valid,
    border,
    dragging,
    borderColor,
    padding,
    background,
    flexDirection,
    error,
    fontWeight,
    labelSize,
    labelColor,
    whiteSpace,
    labelTitle,
    multiple = false,
    ...sx
}) => {
    const [isDragging, setIsDragging] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const files = e.dataTransfer.files;
            if (onChange) {
                onChange({ target: { files } });
            }
            e.dataTransfer.clearData();
        }
    };

    const handleBrowseFileClick = () => {
        document.getElementById(name).click();
    };

    return (
        <>
            {text && (
                <Box mb={0.5}>
                    <Box display="flex" fontSize="12px" flexDirection="row">
                        <InputLabel
                            sx={{
                                letterSpacing: "0.03em",
                                marginRight: "2px",
                                fontWeight: fontWeight,
                                fontSize: labelSize || "14px",
                                color: labelColor || "#222222",
                                whiteSpace: whiteSpace ? "wrap" : "nowrap",
                                marginBottom: "0px",
                            }}
                        >
                            {text}
                        </InputLabel>
                        {valid && (
                            <Typography color="#EF627A" component="caption" variant="body2">
                                *
                            </Typography>
                        )}
                    </Box>
                    <TextLabel fontSize={"12px"} color='#ed6c02' title="નોંધ : કૃપા કરીને સ્પષ્ટ છબી અપલોડ કરો" fontWeight={400} />
                </Box>
            )}
            <Box
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={handleBrowseFileClick}
                sx={{
                    ...sx,
                    position: "relative",
                    border: border || `2px dashed ${isDragging ? "blue" : borderColor || "#D0D0D0"}`,
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "grab",
                    padding: padding || { xs: "10px 20px", sm: "20px 20px", lg: "25px 10px" },
                    background: background,
                }}
            >
                <Box
                    justifyContent="center"
                    display="flex"
                    flexDirection={flexDirection || "column"}
                    alignItems="center"
                    textAlign="center"
                >
                    <SidebarIcon src="images/upload.png" width="35px" height="35px" />
                    <TextLabel
                        title="Choose a file or drag & drop it here"
                        textAlign="center"
                        color="#3E4094"
                        marginTop="10px"
                        fontSize={{ xs: "14px", lg: "20px" }}
                        width={{ xs: "100%", sm: "100%" }}
                    />
                    <TextLabel
                        title={labelTitle}
                        textAlign="center"
                        color="#8b8cbf"
                        fontSize={{ xs: "13px", lg: "16px" }}
                        width={{ xs: "100%", sm: "100%" }}
                    />
                    <ButtonContained
                        minWidth="100px"
                        text="Browse File"
                        padding={{ xs: "5px 10px", md: "10px 20px" }}
                        fontSize={{ xs: "10px", lg: "11px" }}
                        height={{ xs: "30px", lg: "35px" }}
                        marginTop="5px"
                        borderRadius="5px"
                    />
                </Box>
                <Input
                    accept={accept || "image/jpeg, image/png, image/jpg"}
                    id={name}
                    type="file"
                    name={name}
                    multiple={multiple}
                    onChange={onChange} // Passes files to parent via onChange
                    onClick={(e) => e.target.value = null} // Reset file input value
                />
            </Box>

            {/* Display error message */}
            {error && (
                <Typography sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                    {error}
                </Typography>
            )}
        </>
    );
};

export default CommonFileUpload;
